import React, { useCallback, useEffect, useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { HeaderWithStats } from "services/MetadataServices";
import { fetchAnalystList } from "services/serviceUtils";
import ChatSessionListContainer from "modules/chat/containers/ChatSessionList";

const ChatSession: React.FC = () => {
  const [analystsList, setAnalystsList] = useState<HeaderWithStats[]>([]);

  const loadAnalysts = useCallback(async () => {
    const list = await fetchAnalystList(false);
    setAnalystsList(list);
  }, []);

  useEffect(() => {
    loadAnalysts();
  }, [loadAnalysts]);

  return (
    <Box h="100vh" w="100%" bg="white" overflow="hidden">
      <Flex h="100%" w="100%" justify="center">
        <Box w="100%" maxW="1000px" h="100%" px={5} py={6} display="flex" flexDirection="column" minH={0}>
          <Box flex={1} display="flex" flexDirection="column" minH={0} mt={6}>
            <ChatSessionListContainer analystsList={analystsList} />
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default ChatSession;
